export type StartVerifyEmailEvent = {
  object: "start_verify_email";
  action: "";
};
export const startVerifyEmailEvent: StartVerifyEmailEvent = {
  object: "start_verify_email",
  action: "",
};
